export default {
      id: "vk-new-usage",
      viewBox: "0 0 31 30",
      url: __webpack_public_path__ + "svgsprite.svg#vk-new",
      toString: function () {
        return this.url;
      }
    }